/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBillingQueryUsers extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("MasterAccountBillingQueryUsers");
    }

    getFixupPrototypeFunction() { return MasterAccountBillingQueryUsers.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBillingQueryUsers>): MasterAccountBillingQueryUsers {
        let obj = Object.assign(new MasterAccountBillingQueryUsers(), model);
        MasterAccountBillingQueryUsers.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBillingQueryUsers>): MasterAccountBillingQueryUsers {
        if (!model) return null;
        return MasterAccountBillingQueryUsers.newInstance(<MasterAccountBillingQueryUsers> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBillingQueryUsers) {
        if (!obj) return;

        models.MasterAccountBillingQueryUsers.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBillingQueryUsers): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MasterAccountBillingQueryUsers.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Names of user
     */
    user_names: Array<string>;

}
